<template>
  <div class="config">
    <el-dialog title="配置" :visible.sync="params.flag" v-dialogDrag :modal="false" ref="confRef"
      :close-on-click-modal="false" :lock-scroll="true" :modal-append-to-body=false :append-to-body="false"
      :before-close="() => params.flag && $parent.toggleProductView('Config')" @closed="dialogClosed">
      <div class="tabs">
        <div :class="{ tab: true, active: activeConfig == 0 }" @click="activeConfig = 0">
          服务栏目
        </div>
        <div :class="{ tab: true, active: activeConfig == 3 }" @click="activeConfig = 3">
          便捷开关
        </div>
        <div :class="{ tab: true, active: activeConfig == 1 }" @click="activeConfig = 1">
          重要点位配置
        </div>
        <div :class="{ tab: true, active: activeConfig == 2 }" @click="activeConfig = 2">
          默认卡片配置
        </div>
      </div>
      <div class="main">
        <div class="column" v-if="activeConfig === 0">
          <el-table :data="columnData" height="90%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column label="操作" width="130px">
              <template slot-scope="scope">
                <div class="opra-box" v-if="scope.row.isdy === 1">
                  <img class="ope-icon" src="@/assets/images/置顶按钮.png" alt="" title="置顶"
                    @click="zhiDingClick('service', scope.row.id)">
                  <img class="ope-icon1" src="@/assets/images/排序-上.png" alt="" title="向上"
                    @click="sortClickUp('service', scope.row.id)">
                  <img class="ope-icon1" src="@/assets/images/排序-下.png" alt="" title="向下"
                    @click="sortClickDown('service', scope.row.id)">
                  <el-switch v-model="scope.row.active" active-color="#85D2FF" inactive-color="#686464"
                    :active-value="1" :inactive-value="0" @change="changeColumnStatus('service', scope.row.id)">
                  </el-switch>
                </div>
                <div class="text" v-else>未订阅</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next"
            :total="columnTotal">
          </el-pagination>
        </div>
        <div class="column" v-if="activeConfig === 3">
          <el-table :data="switchData" height="90%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column label="操作" width="130px">
              <template slot-scope="scope">
                <div class="opra-box" v-if="scope.row.isdy === 1">
                  <img class="ope-icon" src="@/assets/images/置顶按钮.png" alt="" title="置顶"
                    @click="zhiDingClick('switch', scope.row.id)">
                  <img class="ope-icon1" src="@/assets/images/排序-上.png" alt="" title="向上"
                    @click="sortClickUp('switch', scope.row.id)">
                  <img class="ope-icon1" src="@/assets/images/排序-下.png" alt="" title="向下"
                    @click="sortClickDown('switch', scope.row.id)">
                  <el-switch v-model="scope.row.active" active-color="#85D2FF" inactive-color="#686464"
                    :active-value="1" :inactive-value="0" @change="changeColumnStatus('switch', scope.row.id)">
                  </el-switch>
                </div>
                <div class="text" v-else>未订阅</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
              :page-size="pageSize" layout="total, prev, pager, next" :total="columnTotal">
            </el-pagination> -->
        </div>
        <div class="important-points" v-show="activeConfig === 1">
          <el-table :data="unitObjs" height="100%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100">
            </el-table-column>
            <el-table-column prop="name" label="站点"> </el-table-column>
            <el-table-column label="操作" width="120px">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.iszy" active-color="#85D2FF" inactive-color="#686464" :active-value="1"
                  :inactive-value="0" @change="changeObjStatus(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="cart-box" v-show="activeConfig === 2">
          <img src="@/assets/images/进入布局图标.png" alt="">
          <div class="card-btn" @click="$parent.cardStatus = '进入布局'">进入布局</div>
          <div class="card-tip">*进入布局后，可以通过头部选择产品，以拖拽的形式进行布局</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiData } from '@/api'
import { mapMutations, mapState } from 'vuex'
export default {
  props: ['params'],
  data() {
    return {
      columnTotal: 0,
      currentPage: 1,
      pageSize: 10,
      columnTotalData: [],
      columnData: [],
      switchData: [],
      activeConfig: 0,
      objsTable: [],
      unitObjs: []
    }
  },
  created() {
    this.getListCloumn()
    this.getUnitObj()
  },
  watch: {
    'params.flag': {
      handler(flag) {
        if (flag) {
          this.columnData = this.handlePage(this.columnTotalData)
          this.setZindex()
        }
      }
    }
  },
  computed: {
    ...mapState('home', ['cartData', 'cardOptions'])
  },

  mounted() {
    this.setZindex()
  },
  methods: {
    ...mapMutations('home', ['changeCartItem', 'changeCardTypes']),
    async getUnitObj() {
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.unitObjs(unit.id)
      this.unitObjs = result.data
    },
    async changeObjStatus(obj) {
      // const params = { objid: obj.id, iszy: obj.iszy }
      const result = await apiData.updateObjZy(obj.id, obj.iszy)
      if (result.status === 200) {
        this.$message.success(result.data)
      } else {
        this.$message.error('修改失败')
      }
    },
    async getListCloumn() {
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      // const params = { unitid: unit.id }
      const result = await apiData.listColumn(unit.id)
      const { switchcols, servercols, cardcols, invalidServercol, invalidSwitchcol } = result.data
      this.columnTotalData = servercols
      this.switchData = switchcols
      this.columnTotalData.map(item => {
        item.active = 0
        if (item.isshow === 1 && item.isdy === 1) {
          item.active = 1
        }
        return item
      })
      this.switchData.map(item => {
        item.active = 0
        if (item.isshow === 1 && item.isdy === 1) {
          item.active = 1
        }
        return item
      })

      this.columnTotal = this.columnTotalData.length
      this.columnData = this.handlePage(this.columnTotalData)
    },
    changeColumnStatus(type, id) {
      if (type === 'service') {
        const index = this.columnTotalData.findIndex(item => item.id === id)
        this.columnTotalData[index].active = this.columnTotalData[index].active === 1 ? 1 : 0
        this.columnData = this.handlePage(this.columnTotalData)
      } else {
        const index = this.switchData.findIndex(item => item.id === id)
        const copyData = JSON.parse(JSON.stringify(this.switchData[index]))
        copyData.active = copyData.active === 1 ? 1 : 0
        this.switchData.splice(index, 1, copyData)
      }
    },
    zhiDingClick(type, id) {
      if (type === 'service') {
        const index = this.columnTotalData.findIndex(item => item.id === id)
        const copyData = JSON.parse(JSON.stringify(this.columnTotalData[index]))
        this.columnTotalData.splice(index, 1)
        this.columnTotalData.unshift(copyData)
        this.columnData = this.handlePage(this.columnTotalData)
      } else {
        const index = this.switchData.findIndex(item => item.id === id)
        const copyData = JSON.parse(JSON.stringify(this.switchData[index]))
        this.switchData.splice(index, 1)
        this.switchData.unshift(copyData)
      }
    },

    sortClickUp(type, id) {
      if (type === 'service') {
        const index = this.columnTotalData.findIndex(item => item.id === id)
        if (index === 0) {
          const copyData = JSON.parse(JSON.stringify(this.columnTotalData[index]))
          this.columnTotalData.splice(index, 1)
          this.columnTotalData.push(copyData)
        } else {
          const copyData = JSON.parse(JSON.stringify(this.columnTotalData[index - 1]))
          this.columnTotalData.splice(index - 1, 1, this.columnTotalData[index])
          this.columnTotalData.splice(index, 1, copyData)
        }
        this.columnData = this.handlePage(this.columnTotalData)
      } else {
        const index = this.switchData.findIndex(item => item.id === id)
        if (index === 0) {
          const copyData = JSON.parse(JSON.stringify(this.switchData[index]))
          this.switchData.splice(index, 1)
          this.switchData.push(copyData)
        } else {
          const copyData = JSON.parse(JSON.stringify(this.switchData[index - 1]))
          this.switchData.splice(index - 1, 1, this.switchData[index])
          this.switchData.splice(index, 1, copyData)
        }
      }
    },

    sortClickDown(type, id) {
      if (type === 'service') {
        const index = this.columnTotalData.findIndex(item => item.id === id)
        if (index === this.columnTotalData.length - 1) {
          const copyData = JSON.parse(JSON.stringify(this.columnTotalData[index]))
          this.columnTotalData.splice(index, 1)
          this.columnTotalData.unshift(copyData)
        } else {
          const copyData = JSON.parse(JSON.stringify(this.columnTotalData[index + 1]))
          this.columnTotalData.splice(index + 1, 1, this.columnTotalData[index])
          this.columnTotalData.splice(index, 1, copyData)
        }
        this.columnData = this.handlePage(this.columnTotalData)
      } else {
        const index = this.switchData.findIndex(item => item.id === id)
        if (index === this.switchData.length - 1) {
          const copyData = JSON.parse(JSON.stringify(this.switchData[index]))
          this.switchData.splice(index, 1)
          this.switchData.unshift(copyData)
        } else {
          const copyData = JSON.parse(JSON.stringify(this.switchData[index + 1]))
          this.switchData.splice(index + 1, 1, this.switchData[index])
          this.switchData.splice(index, 1, copyData)
        }
      }
    },

    async dialogClosed() {
      let objids = []
      let invalidcolumnids = []
      this.columnTotalData.forEach(item => {
        if (item.isdy === 1) {
          objids.push(item.id)
          if (item.active === 0 && item.isdy === 1) {
            invalidcolumnids.push(item.id)
          }
        }
      })
      objids = objids.join(',')
      invalidcolumnids = invalidcolumnids.join(',')
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))

      let switchids = []
      let invalidSwitchds = []
      this.switchData.forEach(item => {
        if (item.isdy === 1) {
          switchids.push(item.id)
          if (item.active === 0) {
            invalidSwitchds.push(item.id)
          }
        }
      })
      switchids = switchids.join(',')
      invalidSwitchds = invalidSwitchds.join(',')

      const result = await apiData.columnSortt({ type: 1, columnids: switchids, unitid: unit.id })
      await apiData.columnSortt({ type: 3, columnids: objids, unitid: unit.id })
      await apiData.changeColunmStatus({ type: 3, invalidcolumnids: invalidcolumnids, unitid: unit.id })
      await apiData.changeColunmStatus({ type: 1, invalidcolumnids: invalidSwitchds, unitid: unit.id })
      const unitResult = await apiData.changeCardStatus({ cardone: this.cartData[0].types.join(','), cardtwo: this.cartData[1].types.join(','), cardthree: this.cartData[2].types.join(','), cardfour: this.cartData[3].types.join(','), cardfive: this.cartData[4].types.join(','), cardsix: this.cartData[5].types.join(','), unitid: unit.id })
      console.log("unitResult", unitResult)
      const unitinfo = JSON.parse(localStorage.getItem(company))
      this.changeCardTypes(JSON.parse(unitResult.data))
      localStorage.setItem(company, JSON.stringify({ unit: JSON.parse(unitResult.data), token: unitinfo.token }))
      if (result.status === 200) {
        this.$message.success('配置成功')
        this.currentPage = 1
        this.$parent.listColumn()
      }
    },
    handlePage(totalData) {
      const start = this.pageSize * (this.currentPage - 1)
      const end = this.pageSize * this.currentPage
      return totalData.slice(start, end)
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.columnData = this.handlePage(this.columnTotalData)
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.columnData = this.handlePage(this.columnTotalData)
    },

    // cart 配置发生改变
    cartItemChange(index) {
      this.changeCartItem({ index: index, data: this.cartData[index] })
    },

    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.confRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }

  }
}
</script>
<style lang="less" scoped>
.config {
  pointer-events: none;

  .tabs {
    display: flex;

    .tab {
      font-size: 1rem;
      font-weight: 600;
      color: #FFF;
      margin-right: 2.5rem;
      cursor: pointer;
    }

    .tab.active {
      color: #81C3FF;
    }
  }

  .main {
    flex: 1;
    position: relative;

    .column,
    .important-points,
    .cart-box {
      position: absolute;
      left: 0;
      top: 1.19rem;
      right: 0;
      bottom: -1.19rem;

      .el-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        /deep/ .el-pager li {
          background: transparent;
          color: #FFF;
        }

        /deep/ .el-pager li.active {
          color: #6FBEFF;
        }

        /deep/ .el-pagination__total {
          color: #FFF;
        }

        /deep/ .btn-prev,
        .btn-next {
          background: transparent;
          color: #FFF;
        }

        /deep/ .btn-next {
          background: transparent;
          color: #FFF;
        }

        /deep/ .el-icon {
          color: #afa7a7
        }
      }
    }

    .cart-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 10.99vw;
      }

      .card-btn {
        width: 5.78vw;
        height: 2.03vw;
        font-size: 0.94vw;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 2.03vw;
        text-align: center;
        background: linear-gradient(180deg, rgba(84, 164, 247, 0.03) 0%, rgba(66, 148, 231, 0.83) 100%);
        border-radius: 0.31vw;
        border: 0.05vw solid #4596E9;
        cursor: pointer;
      }

      .card-tip {
        margin-top: 3.85vw;
        font-size: 0.83vw;
        color: #F7C726;
      }
    }

    .el-table {
      .opra-box {
        display: flex;
        align-items: center;
      }

      .ope-icon1 {
        margin: 0px 0.42vw;
      }

      background: transparent;
      text-align: center;

      /deep/ tr {
        background: transparent;

        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #3C7CB8;
        }

        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          background: transparent;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .print {
          width: 1.13rem;
          height: 1.13rem;
          background: url("../assets/images/打印.png") no-repeat;
          border: 0;
          cursor: pointer;
          background-size: 1.13rem 1.13rem;
        }

        .image {
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }

      /deep/ tr:hover td {
        background: #3C7CB8 !important;
      }

      .new {
        margin-left: 0.52vw;
        background-color: #f56c6c;
        border-radius: 0.32vw;
        color: #fff;
        display: inline-block;
        font-size: 0.43vw;
        height: 0.94vw;
        line-height: 0.94vw;
        padding: 0.1vw 0.31vw;
        text-align: center;
        white-space: nowrap;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #273458;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #1b2230;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #0C4170;
      }

      /deep/.el-table__fixed-right-patch {
        background: #f8faff;
        border: 0;
      }
    }

    .el-table::before,
    /deep/.el-table__fixed-right::before {
      background: transparent;
    }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      pointer-events: auto;
      width: 59.5rem;
    }
  }
}

/deep/ .el-input__inner {
  background: #0C4170;
  border: 1px solid #52607F;
}

/deep/ .el-tag {
  background: #354c80;
  border: 1px solid #16223e;
  color: #FFF
}

img {
  cursor: pointer;
}
</style>
